/* eslint-disable max-statements */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useParams} from 'react-router';
import {Card, Tab} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import Header from '../internalCommons/header';
import HeaderForm from './headerForm';
import ShowOrdersTable from './showOrdersTable';
import ShipmentsTable from '../shipments/shipmentsTable';
import ShipmentHeader from '../shipments/shipmentHeader';
import {createOrderScreens} from '../../constants/internalScreens';

const ShowManageOrder = (props) => {
  const {id} = useParams();
  useEffect(() => {
    props.fetchGetOriginData(id);
    props.fetchOrigins();
    props.fetchProviders();
    props.fetchDealers('dealers-vehicles');
    props.fetchSelectModelTempOrders(id.substring(4, 6));
    props.fetchGetShipmentData(id);
    return () => props.cleanHeaderValues();
  }, []);

  const handleChange = (value) => {
    props.setOrder(value);
  };

  const [isShipmentScreen, setIsShipmentScreen] = useState(false);
  
  const handleChangeShipment = (value) => {
    props.updateShipmentTable(value);
  };
  const [filteredData, setFilteredData] = useState([]);
  const panes = [
    {
      'menuItem': 'Detalle de vehículos cargados',
      'render': () => {
        setIsShipmentScreen(false);
        props.showShipmentHeader && props.setShowShipmentHeader(false);
        return (
          <Tab.Pane>
            {props.listDealers && (
              <>
                <ShowOrdersTable
                  dataTable={props.originsAllData.resultDetail}
                  handleChange={handleChange}
                  shipmentsNumber={props?.originsAllData?.shipmentsNumber || 0}
                  setFilteredData={setFilteredData}
                />
              </>
            )}
          </Tab.Pane>
        );
      },
    },
    {
      'menuItem': ' Registro embarques',
      'render': () => {
        setIsShipmentScreen(true);
        return (
          <Tab.Pane>
            {props.ordersByShipment && props.ordersByShipmentMapped && (
              <ShipmentsTable
                dataTable={props.ordersByShipment}
                dataTableFormated={props.ordersByShipmentMapped}
                handleChange={handleChangeShipment}
              />
            )}
          </Tab.Pane>
        );
      },
    },
  ];

  return (
    <>
      <Header
        screen={createOrderScreens.show}
        title={'Ver Orden'}
        isShipmentScreen={isShipmentScreen}
        filteredData={filteredData}
      />
      {props.showShipmentHeader ? (
        <ShipmentHeader />) : (<HeaderForm />
      )}
      {!(!props?.originsAllData?.resultDetail || props.loading) && (
        <Card raised fluid className={'small-container-show'}>
          <Tab
            menu={{'color': 'blue', 'inverted': true, 'attached': true, 'tabular': false}}
            panes={panes} className='custom-tab w-100'
          />
        </Card>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'loading': state.manageOrders.loading,
    'originsAllData': state.manageOrders.originsAllData,
    'listDealers': state.dealer.list,
    'showShipmentHeader': state.manageOrders.showShipmentHeader,
    'ordersByShipment': state.manageOrders.ordersByShipment,
    'ordersByShipmentMapped': state.manageOrders.ordersByShipmentMapped,
  };
};

const {
  addTempOrder,
  cleanHeaderValues,
  cleanTempOrder,
  fetchAddTempOrders,
  fetchDealers,
  fetchGetOriginData,
  fetchOrigins,
  fetchProviders,
  fetchSelectModelTempOrders,
  fetchGetShipmentData,
  setCleanShipmentHeader,
  setOrder,
  setShowShipmentHeader,
  setShipmentHeader,
  setShowShipmentHeaderShip,
  setUpdateShipmentHeader,
  updateShipmentTable,
  updateTempOrder,
} = Actions;

export default connect(mapStateToProps, {
  addTempOrder,
  cleanHeaderValues,
  cleanTempOrder,
  fetchAddTempOrders,
  fetchDealers,
  fetchGetOriginData,
  fetchOrigins,
  fetchProviders,
  fetchSelectModelTempOrders,
  fetchGetShipmentData,
  setCleanShipmentHeader,
  setOrder,
  setShowShipmentHeader,
  setShipmentHeader,
  setShowShipmentHeaderShip,
  setUpdateShipmentHeader,
  updateShipmentTable,
  updateTempOrder,
})(ShowManageOrder);
